import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/markdown-document-screen';
import { TERMS_OF_SERVICE } from './Constants.ts';
import termsOfService from './fans-fund-me-terms-of-service-06032025.md';

function TermsOfService() {
  return (
    <Screen title={TERMS_OF_SERVICE.TITLE_TEXT} subtitle={TERMS_OF_SERVICE.SUBTITLE_TEXT} content={termsOfService} />
  );
}

export default TermsOfService;
